export namespace Wording {

  export const TRANSLATION_NATIVE_LANG_HELP = `<p>This translation language has been set as the default because you selected it
    as the “native” language when creating the playlist <a class='playlist_name'>{groupName}</a>.</p>
    <p>To change the default translation language, simply create a new playlist and choose a different “native” language during setup.</p>`;
}